import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import NavMenu from './NavMenu';
import * as utils from './Utils.js'

const things = {
  'places': [
    {
      'title': 'The Breakers',
      'description': 'Visit the grandest of the Newport mansions, just a few minutes from downtown Newport by car. Anna took Chandler here on his first visit to Newport in 2023.',
      'website': 'https://www.newportmansions.org/mansions-and-gardens/the-breakers',
      'map_apple': 'https://maps.apple.com/place?address=44%20Ochre%20Point%20Ave,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.469804,-71.298157&name=The%20Breakers&place-id=I19EEA8F96A09C1D2&map=explore',
      'map_google': 'https://maps.app.goo.gl/Hrq77cQa5cNmtYfJ6'
    },
    {
      'title': 'Cliff Walk',
      'description': '3.5-mile scenic walk along the coastline with views of the ocean and Newport mansions.',
      'website': 'https://www.discovernewport.org/things-to-do/cliff-walk',
      'map_apple': 'https://maps.apple.com/place?address=Newport,%20RI%2002840,%20United%20States&coordinate=41.485161,-71.297571&name=Cliff%20Walk&place-id=IB71EFA56947000D6&map=explore',
      'map_google': 'https://maps.app.goo.gl/RZEMss3aseS9KLzU6'
    },
    {
      'title': "Bannister's Wharf",
      'description': 'The Anchor of the Newport Waterfront! Marina, restaurants & bars, tours, boutiques & galleries.',
      'website': 'https://www.bannistersnewport.com',
      'map_apple': 'https://maps.apple.com/place?address=Bannisters%20Wharf,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.486257,-71.315978&name=Bannisters%20Wharf&map=explore',
      'map_google': 'https://maps.app.goo.gl/mREfRkaTcUfzqBWu9'
    },
    {
      'title': 'Newport Classic Cruises',
      'description': "Anna and Chandler's favorite for Newport harbor cruises - especially at sunset.",
      'website': 'https://sail-newport.com',
      'map_apple': 'https://maps.apple.com/place?address=24%20Bannisters%20Wharf,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.486171,-71.315880&name=Newport%20Classic%20Cruises&place-id=ID62EFB719A8042B4&map=explore',
      'map_google': 'https://maps.app.goo.gl/2qXo38Ny7HzjPv7Z9'
    },
    {
      'title': 'International Tennis Hall of Fame',
      'description': "Explore the history of tennis at this museum packed with memorabilia, exhibits, and beautiful grass courts.",
      'website': 'https://www.tennisfame.com',
      'map_apple': 'https://maps.apple.com/place?address=194%20Bellevue%20Ave,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.482799,-71.308357&name=International%20Tennis%20Hall%20of%20Fame&place-id=IE679B1CF2B9EF81F&map=explore',
      'map_google': 'https://maps.app.goo.gl/u5c7EwQ82VK7mCzo8'
    }
  ],
  'food-and-drink': [
    {
      'title': 'Perro Salado',
      'description': "Anna and Chandler's favorite Mexican restaurant in Newport. Also, where we first said 'I love you'.",
      'website': 'https://www.perrosalado.com',
      'map_apple': 'https://maps.apple.com/place?address=19%20Charles%20St,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.490745,-71.314335&name=Perro%20Salado&place-id=I61979172A70BDDD2&map=explore',
      'map_google': 'https://maps.app.goo.gl/VEUV3G8daMfjzEr97',
      'sub-categories': {
        'style': 'Mexican',
        'occasion': ['dinner']
      },
      'anna-and-chandler-note': "Get some spicy margaritas!"
    },
    {
      'title': 'Clark Cooke House',
      'description': "Come enjoy a nice lunch or dinner at the wharf at this Newport staple with excellent food and drinks, and no shortage of yachting memorabilia adorning the walls.",
      'website': 'https://www.clarkecooke.com/',
      'map_apple': "https://maps.apple.com/place?address=24%20Bannister's%20Wharf,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.486167,-71.315882&name=The%20Clarke%20Cooke%20House&place-id=IA563F4EEA4510C6A&map=explore",
      'map_google': 'https://www.google.com/maps/place/Clarke+Cooke+House/data=!4m2!3m1!1s0x0:0xb85972a84f2c77e7?sa=X&ved=1t:2428&ictx=111',
      'sub-categories': {
        'style': 'Seafood / American',
        'occasion': ['lunch', 'drink', 'dinner']
      },
      'anna-and-chandler-note': "Can't go wrong with their 'Candy Store Burger' and fries or try any of their amazing seafood options...top it off with an espresso martini."
    },
    {
      'title': 'The Nitro Bar',
      'description': 'Trendy coffee shop serving light fare, breakfast burritos & muffins, plus coffees with a twist.',
      'website': 'http://www.thenitrocart.com/',
      'map_apple': 'https://maps.apple.com/place?address=404%20Thames%20St,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.482323,-71.314343&name=The%20Nitro%20Bar&place-id=I23AAA7E3FDA86DB5&map=explore',
      'map_google': 'https://maps.app.goo.gl/TzULA6jRpHuoaFFU8',
      'sub-categories': {
        'style': 'Coffee Shop and Cafe',
        'occasion': ['coffee', 'breakfast', 'lunch']
      },
      'anna-and-chandler-note': "Get the carmelized banana or cinnamon sugar latte and a breakfast burrito"
    },
    {
      'title': 'The Mooring Seafood Kitchen & Bar',
      'description': 'Upscale seafood restaurant with great food and nice harbor views. Also a great spot for a drink at their bar.',
      'website': 'https://www.mooringrestaurant.com',
      'map_apple': 'https://maps.apple.com/place?address=1%20Sayers%20Wharf%0ANewport,%20RI%20%2002840%0AUnited%20States&coordinate=41.485784,-71.316317&name=The%20Mooring%20Seafood%20Kitchen%20%26%20Bar&place-id=I513C5D75EE042B42&map=explore',
      'map_google': 'https://maps.app.goo.gl/KLUgQgLjWgaMf88Y8',
      'sub-categories': {
        'style': 'Seafood / American',
        'occasion': ['lunch', 'dinner', 'drink']
      },
      'anna-and-chandler-note': ""
    },
    {
      'title': 'Black Pearl',
      'description': "An amazing spot for lunch or a drink at the wharf. Views of the harbor surrounded by boats, shops, and other fun places.",
      'website': 'http://blackpearlnewport.com/',
      'map_apple': 'https://maps.apple.com/place?address=30%20Bannisters%20Wharf,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.486190,-71.316403&name=Black%20Pearl&place-id=I9E3E4D86B963EFA1&map=explore',
      'map_google': 'https://maps.app.goo.gl/MNtnwveUFehhizQm9',
      'sub-categories': {
        'style': 'Seafood / American',
        'occasion': ['lunch', 'drink']
      },
      'anna-and-chandler-note': "Get their famous mudslide and for food go for the amazing burger or cod wrap"
    },
    {
      'title': 'Giusto',
      'description': 'Chic Italian eatery featuring pasta, meat plates & seafood, plus cocktails, wine & water views.',
      'website': 'http://www.giustonewport.com/',
      'map_apple': 'https://maps.apple.com/place?address=4%20Commercial%20Wharf,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.485068,-71.315507&name=Giusto&place-id=IE142498F385C2287&map=explore',
      'map_google': 'https://maps.app.goo.gl/VzBjEKvVWVMX8zxU9',
      'sub-categories': {
        'style': 'Italian',
        'occasion': ['lunch', 'dinner']
      },
      'anna-and-chandler-note': ""
    }
  ],
  'exercise': [
    {
      'title': 'Mend Yoga',
      'website': 'https://www.mendyogari.com/',
      'map_apple': 'https://maps.apple.com/place?address=4%20Equality%20Park%20Pl,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.494314,-71.309591&name=Mend%20Yoga&place-id=I6F250368A007B478&map=explore',
      'map_google': 'https://maps.app.goo.gl/ZgYvdYVnGNPwdSqU7'
    },
    {
      'title': 'btone Pilates',
      'website': 'https://www.btonefitness.com/locations/newport',
      'map_apple': 'https://maps.apple.com/place?address=288%20E%20Main%20Rd,%20Middletown,%20RI%20%2002842,%20United%20States&coordinate=41.520579,-71.292135&name=btone%20Fitness%20Newport&place-id=I7576C433C169E892&map=explore',
      'map_google': 'https://maps.app.goo.gl/wp7cZy5t465Ka5P27'
    },
    {
      'title': 'Thrive Pilates',
      'website': 'http://www.thrivenewport.com/',
      'map_apple': 'https://maps.apple.com/place?address=580%20Thames%20St,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.476780,-71.313606&name=Thrive&place-id=IBBBA28E11C66FCCB&map=explore',
      'map_google': 'https://maps.app.goo.gl/nv5SF7yv2hWWzJi7A'
    }
  ]
}

const ThingsToDo = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="ThingsToDo">
      <Helmet>
        <title>Things To Do</title>
        <meta
          name="description"
          content="Check out exciting things to do in Newport - Mansions, Restaurants, and Bars"
        />

        <meta property="og:title" content="Things To Do | Chandler & Anna" />
        <meta
          property="og:description"
          content="Check out exciting things to do in Newport - Mansions, Restaurants, and Bars"
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/things_to_do.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/things-to-do" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Things To Do</p>
          <div className='things-to-do-categories'>
            <div className='things-to-do-list-item-links'>
              <a href="#places">Places</a>
              <a href="#food-and-drink">Food & Drink</a>
              <a href="#exercise">Exercise</a>
            </div>
          </div>

          <div className='things-to-do-container'>
            <div id="places" className='things-to-do-category'>
              <p className='things-to-do-category-title'>Places</p>
              <div className='things-to-do-list'>
                {things['places'].map((thing) => (
                  <div key={thing.title} className='things-to-do-list-item'>
                    <p className='things-to-do-list-item-title'>{thing.title}</p>
                    <div className='things-to-do-list-item-links'>
                      { thing.website ? <a href={thing.website} target="_blank" rel="noopener noreferrer">Website</a> : '' }
                      { thing.website  && thing.map_apple || thing.map_google ? <span className='pretty-asterisk-small'>*</span> : '' }
                      { thing.map_apple ? <a href={thing.map_apple} target="_blank" rel="noopener noreferrer"> Map</a> : '' }
                      { thing.map_apple && thing.map_google ? '|' : '' }
                      { thing.map_google ? <a href={thing.map_google} target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a> : '' }
                    </div>
                    { thing.description ? <p className='things-to-do-list-item-description'>{thing.description}</p> : '' }
                  </div>
                ))}
              </div>
            </div>

            <div id="food-and-drink" className='things-to-do-category'>
              <p className='things-to-do-category-title'>Food & Drink</p>
              <div className='things-to-do-list'>
                {things['food-and-drink'].map((thing) => (
                  <div key={thing.title} className='things-to-do-list-item'>
                    <p className='things-to-do-list-item-title'>{thing.title}</p>
                    <p className='things-to-do-list-item-sub-categories-style'>{thing['sub-categories'].style}</p>
                    <div className='things-to-do-list-item-links'>
                      { thing.website ? <a href={thing.website} target="_blank" rel="noopener noreferrer">Website</a> : '' }
                      { thing.website  && thing.map_apple || thing.map_google ? <span className='pretty-asterisk-small'>*</span> : '' }
                      { thing.map_apple ? <a href={thing.map_apple} target="_blank" rel="noopener noreferrer"> Map</a> : '' }
                      { thing.map_apple && thing.map_google ? '|' : '' }
                      { thing.map_google ? <a href={thing.map_google} target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a> : '' }
                    </div>
                    { thing['anna-and-chandler-note'] ? <p className='things-to-do-list-item-note blue'>{thing['anna-and-chandler-note']}</p> : '' }
                    { thing.description ? <p className='things-to-do-list-item-description'>{thing.description}</p> : '' }
                  </div>
                ))}
              </div>
            </div>

            <div id="exercise" className='things-to-do-category'>
              <p className='things-to-do-category-title'>Exercise</p>
              <div className='things-to-do-list'>
                {things['exercise'].map((thing) => (
                  <div key={thing.title} className='things-to-do-list-item'>
                    <p className='things-to-do-list-item-title'>{thing.title}</p>
                    <div className='things-to-do-list-item-links'>
                      { thing.website ? <a href={thing.website} target="_blank" rel="noopener noreferrer">Website</a> : '' }
                      { thing.website  && thing.map_apple || thing.map_google ? <span className='pretty-asterisk-small'>*</span> : '' }
                      { thing.map_apple ? <a href={thing.map_apple} target="_blank" rel="noopener noreferrer"> Map</a> : '' }
                      { thing.map_apple && thing.map_google ? '|' : '' }
                      { thing.map_google ? <a href={thing.map_google} target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a> : '' }
                    </div>
                    { thing.description ? <p className='things-to-do-list-item-description'>{thing.description}</p> : '' }
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='things-to-do-footer'>
            <p className='things-to-do-footer-text'>
              For more ideas, check out{" "}
              <a
                className='things-to-do-footer-link link-to-page'
                href='https://www.discovernewport.org/things-to-do/'
                target='_blank'
                rel="noreferrer"
              >
                Things To Do in Newport
              </a>.
            </p>
          </div>

        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['green', 'ivory']) }
      </div>
    </div>
  );
}

export default ThingsToDo;
